import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { hookFormZod } from '@ipfabric/ui-components/utils/hookForm/hookFormZod';
import { loginTimeouts } from '@ipfabric/utils';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

export type LoginTimeoutFieldValues = { loginTimeout: string };
export type LoginTimeoutOutputValues = { loginTimeout: number };

export const loginTimeout: FormSnippet<
  DiscoverySettingsObject,
  LoginTimeoutFieldValues,
  LoginTimeoutOutputValues
> = {
  render: ({ form }) => (
    <FormTextField
      control={form.control}
      type='number'
      name='loginTimeout'
      description='Time to wait for login'
      label='Device login'
      endAdornment='seconds'
      inputWidthClassName='w-60'
    />
  ), // Placeholder for the actual component
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.loginTimeout = model.timeouts?.login?.toString() ?? '';
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.timeouts ??= {};
    modelDraft.timeouts.login = transformedValues.loginTimeout;
  },
  schema: z.object({
    loginTimeout: hookFormZod.numberInputWith(
      hookFormZod.minMax(loginTimeouts.min, loginTimeouts.max),
    ),
  }),
};
